import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import { useFormattingContext } from '../../organisms/FormattingProvider/FormattingContext'
import OpalHeading from '../../opal/OpalHeading'
import OpalCard from '../../opal/OpalCard'
import FlexColumn from '../FlexColumn'
import FlexRow from '../FlexRow'
import Markup from '../../atoms/Markup'

function ActivityDialogBody ({ item }) {
  const descriptionHtml = useMemo(() => {
    return item?.description || item?.content
  }, [item])

  const { formatter } = useFormattingContext()
  const activity = item

  if (!item) return null

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <OpalHeading className='font-size-md'>Status</OpalHeading>
        <OpalHeading
          className='font-size-sm'
          style={{ color: activity.completed ? 'var(--color-success-500)' : 'var(--color-warning-500)' }}
        >
          {activity.completed ? 'Completed' : 'Not Completed'}
        </OpalHeading>
      </Grid>
      <Grid item xs={12} md={4}>
        <OpalHeading className='font-size-md'>Started</OpalHeading>
        <div
          className='font-size-sm'
          style={{ fontWeight: '100' }}
        >{formatter(activity.startDate, '&M/D/YY h:mm a')}
        </div>
      </Grid>
      <Grid item xs={12} md={4}>
        <OpalHeading className='font-size-md'>Due</OpalHeading>
        <div className='font-size-sm' style={{ fontWeight: '100' }}>{formatter(activity.endDate, '&M/D/YY h:mm a')}</div>
      </Grid>
      {descriptionHtml ? (
        <Grid item xs={12}>
          <OpalHeading className='font-size-md'>Description</OpalHeading>
          <OpalCard size='md'>
            <Markup type='html' value={descriptionHtml} />
          </OpalCard>
        </Grid>
      ) : null}
      {activity.attendees?.length ? (
        <Grid item xs={12}>
          <OpalHeading className='font-size-md mb-2'>Attendees</OpalHeading>
          <FlexColumn>
            {activity.attendees.map((attendee) => (
              <FlexRow key={`attendee_${attendee.id}`}>
                <div>{attendee.name}</div>
                {attendee.email ? (<a href={`mailto:${attendee.email}`}>({attendee.email})</a>) : null}
              </FlexRow>
            ))}
          </FlexColumn>
        </Grid>
      ) : null}
    </Grid>
  )
}

ActivityDialogBody.propTypes = {
  item: PropTypes.object
}

export default ActivityDialogBody
